<template>
  <div>
    <div class="main-content">
      <div class="subtitle costTitle">
        {{ $t('message["105"]') }}
      </div>
      <div
        v-if="collapseData.length===0"
        class="no-cost-maintain"
      >
        <p><i class="iconfont iconicon-test38 logo" /></p>
        <p>
          {{ $t('message["173"]') }}
        </p>
      </div>
      <div
        v-for="(item, key) in collapseData"
        v-else
        :key="key"
      >
        <div class="year-title">
          <span>{{ key }}</span>
        </div>
        <a-collapse
          default-active-key="1"
          :bordered="false"
          @change="changeActivekey($event,key)"
        >
          <a-collapse-panel
            v-for="items in item"
            :key="items.period"
            class="collapse-panel"
          >
            <template slot="header">
              {{ items.name }}
              <span
                v-if="items.status===0"
                class="remain-operate-span"
                @click="handleSubmit(items,0)"
              >{{ $t('message["144"]') }}</span>
              <span
                v-else
                class="detail-btn-span"
                @click="handleSubmit(items,1,key)"
              >{{ $t('message["1316"]') }}</span>
            </template>
            <a-table
              :columns="costIndexColumns"
              :data-source="items.data"
              :pagination="false"
            />
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
    <a-spin
      v-if="loadingContent"
      class="spin-style"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      localDataJson: {},
      collapseData: {},
      costMaintainDetailLocal: {}
    }
  },
  computed: {
    ...mapState('costMaintain/costDetail', ['costMaintainDetail']),
    ...mapState('costMaintain/costIndexData', ['costIndexColumns', 'loadingContent', 'costIndexData'])
  },
  watch: {
    costIndexData (val) {
      if (val) {
        this.collapseData = val
        document.title = `${this.$t('message["105"]')}-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
      }
    },
    costMaintainDetail (val) {
      if (val) {
        let tempvs = JSON.parse(JSON.stringify(this.collapseData))
        const keysArray = Object.keys(val)
        keysArray.map(value => {
          const datas = tempvs[value]
          datas.map(vvs => {
            if (val[value][vvs.period]) {
              vvs.data = this.formateIndexDatas(val[value][vvs.period])
            }
          })
        })
        this.collapseData = tempvs
        this.costMaintainDetailLocal = val
      }
    }
  },
  mounted () {
    this.fetchGetCostIndex()
    if (this.costIndexData.length > 0) {
      this.collapseData = this.costIndexData
    }
  },
  methods: {
    ...mapActions('costMaintain/costDetail', ['fetchGetCostDetail']),
    ...mapActions('costMaintain/costIndexData', ['fetchGetCostIndex']),
    formateIndexDatas (array) {
      array.map(value => {
        value.key = value.addtime
        if (Array.isArray(value.memberStr)) {
          let strMember = ''
          value.memberStr.map(vvs => {
            strMember += (vvs + '-')
          })
          strMember = strMember.substring(0, strMember.length - 1)
          value.maintainContent = strMember
        }
        if (Array.isArray(value.fromStr)) {
          let strFrom = ''
          value.fromStr.map(vvs => {
            strFrom += (vvs + '-')
          })
          strFrom = strFrom.substring(0, strFrom.length - 1)
          value.maintainFrom = strFrom
        }
      })
      return array
    },
    handleSubmit (value, flag, year) {
      this.$router.push({
        path: `/project/${this.$route.params.pid}/cost/maintain/detail`,
        query: {
          period: value.period
        }
      })
    },
    formateCostData () {
    },
    changeActivekey (key, item) {
      if (!this.localDataJson[item]) {
        this.localDataJson[item] = key
      }
      const diffArr = this.getArrDifference(this.localDataJson[item], key)
      if (Array.isArray(diffArr)) {
        if (diffArr.length === 0) {
          this.fetchGetCostDetail({ period: key[1], key: item })
        } else {
          this.fetchGetCostDetail({ period: diffArr[0], key: item })
        }
      }
      this.localDataJson[item] = key
    },
    getArrDifference (arr1, arr2) {
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
    }
  }
}
</script>
<style lang="scss">
.anticon-right {
  padding-top: 4px !important;
}
.ant-collapse-item {
  border-bottom: solid 1px #ebebeb !important;
  &:last-child {
    border-bottom: none !important;
  }
}
</style>

<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.editable-add-btn {
  margin-bottom: 16px;
}
.costTitle {
  margin-top: 16px;
  margin-bottom: 16px;
}
.month-date-div {
  margin-top: 24px;
  margin-bottom: 24px;
  .month-picker-style {
    width: 300px;
  }
}
.spin-style {
  position: absolute;
  top: 50%;
  left: 50%;
}
.no-cost-maintain {
  width: 1040px;
  margin-top: 40px;
  .logo {
    font-size: 24px;
  }
  p {
    text-align: center;
    height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(179, 179, 179, 1);
    line-height: 24px;
    margin-bottom: 8px;
  }
}
.year-title {
  height: 48px;
  border-bottom: solid 1px #ebebeb;
  &:first-child {
    border-top: solid 1px #ebebeb;
  }
  span {
    font-size: 24px;
    font-weight: 600;
    height: 48px;
    line-height: 48px;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #333333;
    margin-left: 12px;
  }
}
.collapse-panel {
  &:last-child {
    border-bottom: none;
  }
}
.detail-btn-span {
  float: right;
  margin-right: 12px;
  height: 32px;
  margin-top: -4px;
  font-size: 14px;
  padding: 4px 12px 4px 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #5077aa;
  &:hover {
    border: solid 1px #ebebeb;
    background-color: #ffffff;
  }
}
.remain-operate-span {
  width: 66px;
  height: 30px;
  border-radius: 4px;
  border: solid 1px #5077aa;
  background-image: linear-gradient(to top, #5077aa, #608fcc);
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-weight: 400;
  float: right;
  margin-right: 12px;
  line-height: 28px;
  text-align: center;
  margin-top: -5px;
}
</style>
